import { buildClinicalSubmitBody } from '../clinical/clinicalSubmitBody';
import type { RDIFormData } from '@odo/shared-ui/clinical/types';
import type { ClinicalEditArgs, ClinicalSubmitArgs } from '../clinical/clinicalWizardConfig';

export type SubmitRdiPayload = ClinicalSubmitArgs<RDIFormData>;

async function submitRdi(payload: SubmitRdiPayload): Promise<void> {
    const { default: apiV2 } = await import('../../../../api/v2');
    const { toApiError } = await import('../../../../services/apiErrors');
    const { uploadFinalPdf } = await import('../../../../services/clinicalDrafts');

    let rdiPdfFileId: string;
    try {
        rdiPdfFileId = await uploadFinalPdf(
            `/patients/${payload.patientId}/clinical/rdi/pdf/upload-url`,
            payload.mergedPdf,
            'rdi.pdf'
        );
    } catch (err) {
        throw toApiError(err);
    }

    const body = { rdiPdfFileId, ...buildClinicalSubmitBody(payload) };

    try {
        await apiV2.post(`/patients/${payload.patientId}/clinical/rdi`, body);
    } catch (err) {
        throw toApiError(err);
    }
}

export type EditRdiPayload = ClinicalEditArgs<RDIFormData>;

async function editRdi(payload: EditRdiPayload): Promise<void> {
    const { default: apiV2 } = await import('../../../../api/v2');
    const { toApiError } = await import('../../../../services/apiErrors');
    const { uploadFinalPdf } = await import('../../../../services/clinicalDrafts');

    let rdiPdfFileId: string;
    try {
        rdiPdfFileId = await uploadFinalPdf(
            `/patients/${payload.patientId}/clinical/rdi/pdf/upload-url`,
            payload.mergedPdf,
            'rdi.pdf'
        );
    } catch (err) {
        throw toApiError(err);
    }

    const body = { rdiPdfFileId, ...buildClinicalSubmitBody(payload) };

    try {
        await apiV2.put(`/patients/${payload.patientId}/clinical/rdi/${payload.eventId}`, body);
    } catch (err) {
        throw toApiError(err);
    }
}

export { submitRdi, editRdi };
